
import {useEffect , useState , useRef} from "react"
import {BrowserRouter as Router , Routes , Route , Link } from 'react-router-dom';

import socket from './../socket.js'

import {useNavigate} from "react-router-dom";
function Home () {
  const navigate = useNavigate ();

  const id=localStorage.getItem ('id');
  const phone=localStorage.getItem ('phone');
  const boards=JSON.parse(localStorage.getItem ('boards'));
  const select_board=localStorage.getItem ('select_board');

  useEffect (()=>{
  },[]);
  return (
    <div style={style.container}>
      <div style={style.content}>

      <h1 style={{textAlign:'center'}}>هوش سبز</h1>
      <h3 style={{textAlign:'center'}}>
        سیستم اتوماسیون گلخانه
      </h3>
      <button  className="btn"
        onClick={()=>{
          if (id!=null && phone!=null && boards!=null && select_board!=null)
            navigate ('/MainApp')
          else
            navigate ('/GetPhone');
        }} >
        وب اپلکیشن
      </button>
      </div>
    </div>
  );
}

const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}


export default Home;
